import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetSlider =
  ({ callback, page, rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.slider.get + `?page=${page}&limit=${rowsPerPage}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteSlider =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.slider.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${id}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageSlider =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.title)) {
        bodyFormData.append("title", values?.title?.trim());
      }
      if (CheckDataIfExit(values?.description)) {
        bodyFormData.append("description", values?.description?.trim());
      }
      if (
        values?.media &&
        values?.media != null &&
        values?.media != undefined &&
        CheckImageIsFile({ data: values?.media, IsBoolean: true })
      ) {
        bodyFormData.append("media", values?.media);
      } else if (editMode && !values?.media) {
        bodyFormData.append("media", "");
      }
      if (
        values?.media_mobile &&
        values?.media_mobile != null &&
        values?.media_mobile != undefined &&
        CheckImageIsFile({ data: values?.media_mobile, IsBoolean: true })
      ) {
        bodyFormData.append("media_mobile", values?.media_mobile);
      } else if (editMode && !values?.media_mobile) {
        bodyFormData.append("media_mobile", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.slider.edit}/${paramID}`
          : UrlApi.slider.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditSlider =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.slider.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
